import {createReducer} from "redux-act";
import {IModalReducer, IReducerAction} from "modules/types";
import {
	closeMaintenanceModal,
	hideErrorModal,
	setIsTutorialViewed,
	showErrorModal,
	toggleGameOverModal,
	toggleTutorialModal,
} from "modules/actions";

const initialState: IModalReducer = {
	errorModalMessage: null,
	isTutorialModalOpen: false,
	isGameOverModalOpen: false,
	isTutorialViewed: false,
	isMaintenanceViewed: false,
};
type IModalReducerPayload<TP = null> = IReducerAction<IModalReducer, TP>;

const onShowErrorModal: IModalReducerPayload<string> = (state, payload) => ({
	...state,
	errorModalMessage: payload,
});

const onHideErrorModal: IModalReducerPayload = (state) => ({
	...state,
	errorModalMessage: null,
});

const onToggleTutorialModal: IModalReducerPayload<boolean> = (state, payload) => ({
	...state,
	isTutorialModalOpen: payload,
});

const onToggleGameOverModal: IModalReducerPayload<boolean> = (state, payload) => ({
	...state,
	isGameOverModalOpen: payload,
});

const onSetIsTutorialViewed: IModalReducerPayload<boolean> = (state, payload) => ({
	...state,
	isTutorialViewed: payload,
});

const onCloseMaintenanceModal: IModalReducerPayload<boolean> = (state, payload) => ({
	...state,
	isMaintenanceViewed: payload,
});

export const modal = createReducer({}, initialState)
	.on(showErrorModal, onShowErrorModal)
	.on(hideErrorModal, onHideErrorModal)
	.on(toggleTutorialModal, onToggleTutorialModal)
	.on(toggleGameOverModal, onToggleGameOverModal)
	.on(setIsTutorialViewed, onSetIsTutorialViewed)
	.on(closeMaintenanceModal, onCloseMaintenanceModal);
